import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { faPlus, faUser } from '@fortawesome/pro-regular-svg-icons';
import theme from 'styles/themes/default';

import Block from 'components/atom/Block';
import Button from 'components/atom/Form/Button';
import Text from 'components/atom/Text/styles';
import AvatarInvitation from 'components/molecule/AvatarInvitational';
import ProfileInfo from 'components/organisms/ProfileInfo';

import { Container, ContainerActions, FooterCard, HeaderCard, InfoUser } from './styles';

interface IUserProspectionCardProps extends IProspection {
  handleInvite: () => void;
}

const UserProspectionCard: React.FC<IUserProspectionCardProps> = ({
  id,
  fullname,
  avatar,
  companyFantasyName,
  interests,
  handleInvite,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [prospectionId, setProspectionId] = useState<string | null>(null);

  const { t } = useTranslation();

  const formatInterests = useMemo(
    () => interests?.map((item) => item.name).join(', '),
    [interests],
  );

  return (
    <Block>
      <Container>
        <HeaderCard>
          <AvatarInvitation name={fullname} src={avatar} type="invite" hideBadge />

          <InfoUser>
            <Text weight="bold" size={16} lineHeight={19.2} color={theme.colors.primary.color}>
              {fullname}
            </Text>

            <Text lineHeight={20} color={theme.colors.texts_light}>
              {companyFantasyName}
            </Text>
          </InfoUser>
        </HeaderCard>

        <hr />

        <FooterCard>
          {formatInterests && (
            <p>
              <strong>{t('meetings:prospection.interests')}</strong> {formatInterests}
            </p>
          )}

          <ContainerActions>
            <Button
              theme="orange"
              text={t('meetings:actions.invite')}
              disabledUppercase
              icon={faPlus}
              iconPosition="right"
              onClick={handleInvite}
            />

            <Button
              theme="light-bordered"
              icon={faUser}
              onClick={() => {
                setProspectionId(id);
                setIsOpenModal(true);
              }}
            />
          </ContainerActions>
        </FooterCard>
      </Container>

      {isOpenModal && prospectionId && (
        <ProfileInfo
          isOpen={isOpenModal}
          onclose={() => {
            setIsOpenModal(false);
            setProspectionId(null);
          }}
          prospectionId={prospectionId}
        />
      )}
    </Block>
  );
};

export default UserProspectionCard;
